import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
`;

export const HeaderRow = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0;
  width: 100%;
  max-width: 720px;
  margin-left: auto;
  margin-right: auto;
  gap: 16px;
  margin-bottom: 8px;
`;

export const TabTitle = styled.h2`
  width: 100%;
  font-size: 24px;
  font-weight: 600;
  color: ${({ theme }) => theme.colors.black10};
  margin: 0;
  text-align: left;
`;

export const StyledCollapse = styled.div`
  width: 100%;

  .ant-collapse {
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.black4};
    border-radius: 16px;
    overflow: hidden;
  }

  .ant-collapse-item {
    border-bottom: 1px solid ${({ theme }) => theme.colors.black4};
  }

  .ant-collapse-item:last-child {
    border-bottom: 0;
  }

  .ant-collapse-header {
    padding: 16px 20px !important;
    font-weight: 600;
    color: ${({ theme }) => theme.colors.black10};
    background: ${({ theme }) => theme.colors.white};
  }

  .ant-collapse-content {
    background: ${({ theme }) => theme.colors.white};
  }

  .ant-collapse-content-box {
    padding: 20px;
  }
`;

export const CollapseContent = styled.div`
  padding: 24px 0;
`;

export const FormGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const FormRow = styled.div<{ columns?: number }>`
  display: grid;
  grid-template-columns: repeat(${props => props.columns || 1}, 1fr);
  gap: 16px;

  @media (max-width: ${({ theme }) => theme.mediaQueries.md}) {
    grid-template-columns: 1fr;
  }
`;

export const CollapseLabel = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 8px;
  align-self: stretch;
  color: ${({ theme }) => theme.colors.black9};
  text-align: center;

  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
`;
